export type IndexDBErrorType = 'IndexDB Error';

export class IndexDBError extends Error {
  constructor(msg = 'IndexDB Error') {
    super(msg);
  }
}
